import Vue from 'vue'
import App from '@base/App.vue'

// Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// local modules
import i18n from '@base/i18n'
import store from '@user/store'
import router from '@user/router'

// library modules
import Loading from 'vue-loading-overlay'
import vueMoment from 'vue-moment'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import 'moment/locale/da'
import 'moment/locale/de'
import 'moment/locale/en-gb'
import 'moment/locale/es'
import 'moment/locale/fi'
import 'moment/locale/fr'
import 'moment/locale/it'
import 'moment/locale/nb'
import 'moment/locale/nl'
import 'moment/locale/pl'
import 'moment/locale/pt'
import 'moment/locale/sv'
import Notifications from 'vue-notification'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import VCalendar from 'v-calendar';
import Paginate from 'vuejs-paginate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueSidebarMenu from 'vue-sidebar-menu'
import VuePhoneNumberInput from 'vue-phone-number-input'
import Multiselect from 'vue-multiselect'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

// CSS
import 'vue-loading-overlay/dist/vue-loading.css'
import '@base/styles/ourStyles.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import 'sweetalert2/dist/sweetalert2.min.css'


library.add(faInstagram, faFacebookF, faPrint)

Vue.use(Notifications)
Vue.use(Loading)
Vue.use(Vuelidate)
Vue.use(vueMoment, {moment})
Vue.use(VCalendar)
Vue.use(VueSweetalert2)
Vue.use(VueSidebarMenu)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueVideoPlayer)

Vue.component('paginate', Paginate)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
Vue.component('vue-phone-number-input', VuePhoneNumberInput)
Vue.component('multiselect', Multiselect)

new Vue({
  i18n,
  store,
  router,
  render: h => h(App)
}).$mount('#app')